import { ReactNode, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getIdToken } from "../lib/auth";
import { LoadingState } from "./Loading";

type SessionState = "checking" | "authenticated" | "anonymous";

/**
 * Route guard. Before this existed, landing on an app route without a valid session rendered the full
 * page chrome and then failed every fetch with "Failed to fetch" -- an error state that looked like a
 * bug rather than "you're signed out". Now an expired session redirects to the login page, remembering
 * where it was headed so signing back in returns there instead of dumping the user on a default page.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const [state, setState] = useState<SessionState>("checking");
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;
    getIdToken().then((token) => {
      if (!cancelled) setState(token ? "authenticated" : "anonymous");
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (state === "checking") {
    return (
      <div className="dashboard">
        <LoadingState label="Checking your session…" />
      </div>
    );
  }

  if (state === "anonymous") {
    return <Navigate to="/signin" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
